/* eslint perfectionist/sort-enums: "off" */

import { themeToVar } from '@toeverything/theme/v2';
import { z } from 'zod';

// 3 x 9
export const PALETTES = [
  // Light
  themeToVar('edgeless/palette/light/redLight'),
  themeToVar('edgeless/palette/light/orangeLight'),
  themeToVar('edgeless/palette/light/yellowLight'),
  themeToVar('edgeless/palette/light/greenLight'),
  themeToVar('edgeless/palette/light/blueLight'),
  themeToVar('edgeless/palette/light/purpleLight'),
  themeToVar('edgeless/palette/light/magentaLight'),
  themeToVar('edgeless/palette/light/greyLight'),
  'transparent',
  // Medium
  themeToVar('edgeless/palette/medium/redMedium'),
  themeToVar('edgeless/palette/medium/orangeMedium'),
  themeToVar('edgeless/palette/medium/yellowMedium'),
  themeToVar('edgeless/palette/medium/greenMedium'),
  themeToVar('edgeless/palette/medium/blueMedium'),
  themeToVar('edgeless/palette/medium/purpleMedium'),
  themeToVar('edgeless/palette/medium/magentaMedium'),
  themeToVar('edgeless/palette/medium/greyMedium'),
  themeToVar('edgeless/palette/white'),
  // Heavy
  themeToVar('edgeless/palette/heavy/red'),
  themeToVar('edgeless/palette/heavy/orange'),
  themeToVar('edgeless/palette/heavy/yellow'),
  themeToVar('edgeless/palette/heavy/green'),
  themeToVar('edgeless/palette/heavy/blue'),
  themeToVar('edgeless/palette/heavy/purple'),
  themeToVar('edgeless/palette/heavy/magenta'),
  themeToVar('edgeless/palette/black'),
] as const;

export const PaletteEnum = z.enum(PALETTES);
export type PaletteEnum = z.infer<typeof PaletteEnum>;
